import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '@environments/environment';

interface LmsSsoResponse {
  redirect_url: string;
}

@Injectable({
  providedIn: 'root',
})
export class LmsService {
  private readonly ssoEndpoint = `${environment.django_login_url}/saml/sso/setup_learnupon_sso/`;

  constructor(private http: HttpClient) {}

  getSsoUrl(): Observable<string> {
    return this.http
      .post<LmsSsoResponse>(this.ssoEndpoint, {
        sp: environment.learnupon_url,
        RelayState: 'Dashboard',
      })
      .pipe(map((response) => response.redirect_url));
  }

  /**
   * Opens the LMS portal in a new tab.
   * Opens a placeholder window synchronously to avoid popup blockers,
   * fetches the SSO URL, then redirects the window.
   * On error, closes the placeholder window and rethrows.
   * @returns Observable<void> that completes on success or errors on failure
   */
  openPortal(): Observable<void> {
    // Open placeholder window synchronously to avoid popup blockers
    const win = window.open('', '_blank');

    return this.getSsoUrl().pipe(
      tap((url) => {
        if (win) {
          win.location.href = url;
        }
      }),
      map(() => undefined),
      catchError((error) => {
        if (win && !win.closed) {
          win.close();
        }
        throw error;
      })
    );
  }
}
